import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-cream py-16 md:py-24" aria-labelledby="guarantee-heading" data-id="element-201" data-mp="4vrzlvp3q9pt">
      <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-202" data-mp="9srynmnjac7f">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} data-id="element-203" data-mp="etpo8kavi8iy">
          {/* Guarantee Seal */}
          <div className="flex justify-center mb-8" data-id="element-204" data-mp="slmaw8trvq7y">
            <div className="relative w-36 h-36" data-id="element-205" data-mp="xk71rhn4wxjq">
              {/* Outer ring */}
              <div className="absolute inset-0 rounded-full border-4 border-forest flex items-center justify-center" data-id="element-206" data-mp="12ja9xayevjvx">
                {/* Inner content */}
                <div className="text-center" data-id="element-207" data-mp="17id39y5141o2">
                  <ShieldCheckIcon className="w-10 h-10 text-forest mx-auto mb-1" aria-hidden="true" data-id="element-208" data-mp="25sggha1qvzyr" />
                  <p className="font-serif text-forest text-xs font-700 leading-tight" data-id="element-209" data-mp="20ux2mb8ylp7c">
                    60-Day
                    <br data-id="element-210" data-mp="1vvkezoa9ke3p" />
                    Guarantee
                  </p>
                </div>
              </div>
              {/* Decorative dashed ring */}
              <svg className="absolute inset-0 w-full h-full -rotate-90" viewBox="0 0 144 144" aria-hidden="true" data-id="element-211" data-mp="2ohwvf2e6fuyp">
                <circle cx="72" cy="72" r="68" fill="none" stroke="#8FAF8A" strokeWidth="2" strokeDasharray="8 4" data-id="element-212" data-mp="2erk14igk8nfd" />
              </svg>
            </div>
          </div>

          <h2 id="guarantee-heading" className="font-serif text-forest text-3xl md:text-4xl font-700 mb-6" data-id="element-213" data-mp="32hecevl8e3xi">
            The 60-Day "Feel Lighter" Guarantee
          </h2>

          <p className="font-sans text-stone-600 text-lg leading-relaxed mb-6 max-w-2xl mx-auto" data-id="element-214" data-mp="15j7as6cszwig">
            Try the entire Cortisol Reset Kitchen system for 60 full days. If
            your bloating hasn't noticeably reduced, if you haven't felt a shift
            in your energy, if you don't feel lighter in your body — email us
            and you pay nothing.
          </p>

          <p className="font-sans text-stone-600 text-lg leading-relaxed mb-8 max-w-2xl mx-auto" data-id="element-215" data-mp="muae5vtxorx2">
            Zero questions asked. Zero hoops to jump through. We're that
            confident this will work for your biology.
          </p>

          <div className="inline-block bg-forest rounded-2xl px-8 py-4" data-id="element-216" data-mp="cx5t5zbtr2hu">
            <p className="font-serif text-cream text-xl italic" data-id="element-217" data-mp="22aj0lxf8h6n6">
              "You have nothing to lose — except the belly."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}